import { Box } from "@mui/material";

import { MaintenanceCC } from "api/public/pcm/pcm.types";
import { withForm } from "components/Forms/AppForm";

import { pcmFormDefaultValues } from "./pcmFormDefaultValues";

const MaintenanceSelectSection = withForm({
  defaultValues: pcmFormDefaultValues,
  props: {
    ccMaintenances: [] as MaintenanceCC[],
  },
  render: function Render({ form, ccMaintenances }) {
    const formattedMaintenances = ccMaintenances.map((ccm) => ({
      label: ccm.name,
      value: ccm.maintenance_id,
    }));
    return (
      <Box sx={{ mb: 4 }}>
        <form.AppField name="ccMaintenance">
          {(field) => (
            <field.AutocompleteSelect
              options={formattedMaintenances}
              label="Maintenance"
              required
            />
          )}
        </form.AppField>
      </Box>
    );
  },
});

export default MaintenanceSelectSection;
